export class EnvironmentUtils {
  public static isMobile(): boolean {
    return window.matchMedia("(max-width: 960px)").matches;
  }
}
